export default "__VITE_ASSET__lZHcRgH5__"